import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

Vue.use(VueI18n)

// / ========== 1. 同步部分：先给一个初始值 ==========
const getInitialLocale = () => {
  // 用户手动选过，最高优先级
  const saved = localStorage.getItem('language')
  if (saved) return saved

  // 如果之前 IP 检测过且存了 sessionStorage，直接用（避免刷新又闪）
  const ipCached = sessionStorage.getItem('ip_detected_locale')
  if (ipCached) return ipCached

  // 兜底：用浏览器语言同步判断
  const browserLang = navigator.language || navigator.userLanguage || 'en-US'
  return browserLang.includes('zh') ? 'zh-CN' : 'en-US'
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

// 设置 Element UI 的语言
ElementLocale.i18n((key, value) => i18n.t(key, value))

// ========== 2. 异步部分：IP 检测后动态修正 ==========
const detectLocaleByIP = async () => {
  // 用户手动设置过语言 → 不覆盖
  if (localStorage.getItem('language')) return

  try {
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), 3000)

    const res = await fetch('https://ipapi.co/json/', { signal: controller.signal })
    clearTimeout(timer)
    const data = await res.json()

    // 国内 → 中文，其他 → 英文
    const newLocale = (data.country_code === 'CN') ? 'zh-CN' : 'en-US'

    // 缓存到 sessionStorage（刷新页面时同步读取，不再闪）
    sessionStorage.setItem('ip_detected_locale', newLocale)

    // 和当前 locale 不同才切换
    if (newLocale !== i18n.locale) {
      i18n.locale = newLocale
    }
  } catch (e) {
    // IP 接口失败，保持浏览器语言判断的结果，不做任何事
    console.log('IP detect failed, keep current locale:', i18n.locale)
  }
}

// i18n 初始化后立即执行检测
detectLocaleByIP()

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js